import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_footprint_generic_json_inventory_export_dataService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { project_lookup_code?: string, material_lookup_code?: string, warehouse_name?: string, render_lots?: boolean, render_license_plates?: boolean, render_serial_numbers?: boolean, debug?: boolean, only_inventory?: boolean, only_physical?: boolean, date_format?: string }): Promise<{ DatexInventoryInfo?: $frontendTypes.FootprintApiManager.DatexInventoryInfo, messages?: any[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

